import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { ErrorBoundary } from "./components/ErrorBoundary.tsx";

// public/maintenance.js holds the app back while the site is in maintenance.
const maintenance = (window as Window & { siteMaintenance?: { ready: Promise<void> } }).siteMaintenance;

(maintenance?.ready ?? Promise.resolve()).then(() => {
  createRoot(document.getElementById("root")!).render(
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  );
});
